import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import typography from "../../../theme/typography";
import { colors } from "../../../theme/palette";
import WeeklyCalendar from "./WeeklyCalendar";
import { Dispatch, SetStateAction } from "react";
import {
  startOfDay,
  endOfDay,
  startOfToday,
  endOfToday,
  startOfTomorrow,
  endOfTomorrow,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  addDays,
} from "date-fns";

const EventsListCalendar = ({
  handleChangeCalendarValue,
  calendarTab,
  setMinDate,
  setMaxDate,
  isLoading,
}: {
  handleChangeCalendarValue: (newValue: string) => void;
  calendarTab: string;
  setMinDate: Dispatch<SetStateAction<string>>;
  setMaxDate: Dispatch<SetStateAction<string>>;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();

  const handleChipClick = (type: string) => {
    let minDate: string = "";
    let maxDate: string = "";

    const today = new Date();

    switch (type) {
      case "TODAY":
        minDate = startOfToday().toISOString();
        maxDate = endOfToday().toISOString();
        break;
      case "TOMORROW":
        minDate = startOfTomorrow().toISOString();
        maxDate = endOfTomorrow().toISOString();
        break;
      case "THIS_WEEK":
        minDate = startOfWeek(today).toISOString();
        maxDate = endOfWeek(today).toISOString();
        break;
      case "THIS_MONTH":
        minDate = startOfMonth(today).toISOString();
        maxDate = endOfMonth(today).toISOString();
        break;
      default:
        minDate = "";
        maxDate = "";
    }

    setMinDate(minDate);
    setMaxDate(maxDate);
    handleChangeCalendarValue(type);
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", marginBottom: "26px" }}
    >
      <Box sx={{ display: "flex", gap: "8px" }}>
        <Chip
          label={t("pages.events.eventList.all")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChipClick("")}
          sx={{
            border: "none",
            padding: "1px 4px",
            color: calendarTab === "" ? colors.Green100 : colors.Dark600,
            background: calendarTab === "" ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("pages.events.eventList.today")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChipClick("TODAY")}
          sx={{
            border: "none",
            padding: "1px 4px",
            color: calendarTab === "TODAY" ? colors.Green100 : colors.Dark600,
            background:
              calendarTab === "TODAY" ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("pages.events.eventList.tomorrow")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChipClick("TOMORROW")}
          sx={{
            border: "none",
            padding: "1px 4px",
            color:
              calendarTab === "TOMORROW" ? colors.Green100 : colors.Dark600,
            background:
              calendarTab === "TOMORROW" ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("pages.events.eventList.thisWeek")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChipClick("THIS_WEEK")}
          sx={{
            border: "none",
            padding: "1px 4px",
            color:
              calendarTab === "THIS_WEEK" ? colors.Green100 : colors.Dark600,
            background:
              calendarTab === "THIS_WEEK" ? colors.Green25 : "transparent",
            marginBottom: "11px",
          }}
        />
        <Chip
          label={t("pages.events.eventList.thisMonth")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChipClick("THIS_MONTH")}
          sx={{
            border: "none",
            padding: "1px 4px",
            color:
              calendarTab === "THIS_MONTH" ? colors.Green100 : colors.Dark600,
            background:
              calendarTab === "THIS_MONTH" ? colors.Green25 : "transparent",
          }}
        />
        <Chip
          label={t("pages.events.eventList.calendar")}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleChipClick("CALENDAR")}
          sx={{
            border: "none",
            padding: "1px 4px",
            color:
              calendarTab === "CALENDAR" ? colors.Green100 : colors.Dark600,
            background:
              calendarTab === "CALENDAR" ? colors.Green25 : "transparent",
          }}
        />
      </Box>
      {calendarTab === "CALENDAR" && (
        <WeeklyCalendar setMinDate={setMinDate} setMaxDate={setMaxDate} />
      )}
    </Box>
  );
};

export default EventsListCalendar;
